module.exports = __webpack_public_path__ + "static/media/logo.e5d44555.png";